// extracted by mini-css-extract-plugin
module.exports = {"metaverse":"index_metaverse__I39GE"};